import { db } from './firebase';

const settings = {timestampsInSnapshots: true};
db.settings(settings);


export const deleteMaterial = (id) =>
  db.collection('Materials').doc(id).delete();

export const deleteVideo = (id) =>
  db.collection('Videos').doc(id).delete();

export const deleteSchool = (id) =>
  db.collection('Schools').doc(id).delete();

export const deleteTask = (id) =>
  db.collection('Tasks').doc(id).delete();


export const deleteUser = (id) =>
  db.collection('Users').doc(id).delete();


export const getActivityByOrg = (orgID) => {
  return new Promise(function(resolve, reject) {
    var baseRef = db.collection('Activity');
    var queryRef = baseRef.where('orgID','==',orgID);
    queryRef.orderBy("modified","desc").get().then(snapshot => {
      var activity = [];
      snapshot.forEach((doc) => {
        var a = doc.data();
        a.id = doc.id;
        activity.push(a);
      })
      resolve(activity);
    });
  });
}

export const getActivityBySchool = (schoolID) => {
  return new Promise(function(resolve, reject) {
    var baseRef = db.collection('Activity');
    var queryRef = baseRef.where('SchoolID','==',schoolID);
    queryRef.orderBy("modified","desc").get().then(snapshot => {
      var activity = [];
      snapshot.forEach((doc) => {
        var a = doc.data();
        a.id = doc.id;
        activity.push(a);
      })
      resolve(activity);
    });
  });
}

export const getActivityByClass = (classID) => {
  return new Promise(function(resolve, reject) {
    var baseRef = db.collection('Activity');
    var queryRef = baseRef.where('ClassID','==',classID);
    queryRef.orderBy("modified","desc").get().then(snapshot => {
      var activity = [];
      snapshot.forEach((doc) => {
        var a = doc.data();
        a.id = doc.id;
        activity.push(a);
      });
      resolve(activity);
    });
  });
}

export const getAlerts = (orgID) => {
  var baseRef = db.collection('Alerts');
  var queryRef = baseRef.where('orgId','==',orgID);
  return queryRef.orderBy("dateTimeSent","desc").get();
}

export const getBlogPosts = () => {
  return db.collection('BlogPosts').orderBy('PublishDate', "desc").get();
}

export const getClasses = (schoolID) => {
  var baseRef = db.collection('Classes');
  if(schoolID) {
    var queryRef = baseRef.where('SchoolID','==',schoolID);
    return queryRef.orderBy("Name","desc").get();
  } else {
    return baseRef.orderBy("Name","desc").get();
  }
}

export const getCourses = () => {
  return db.collection('Courses').orderBy("Name","desc").get();
}

export const getLessons = (courseID) => {
  var baseRef = db.collection('Lessons');
  var queryRef = baseRef.where('Course','==',courseID);
  return queryRef.orderBy("Quarter","desc").orderBy("Week","desc").get();
}

export const getRecentOrders = (startAfter) => {
  
  return new Promise(function(resolve, reject) {
    var baseRef = db.collection('Orders');
    var queryRef = baseRef.orderBy('modified','desc');
    if(startAfter) {
      queryRef = queryRef.startAfter(startAfter);
    }
    
    return queryRef.limit(180).get().then(snapshot => {
      var objs = [];
      snapshot.forEach((doc) => {
        var d = doc.data();
        d.id = doc.id;
        objs.push(d);
      });
      
      resolve(objs);
    });
  });
}

export const getMaterials = (orgID) => {
  var baseRef = db.collection('Materials');
  //var queryRef = baseRef.where('ClassID','==',classID);
  return baseRef.get();
}
  
export const getOrganization = (id) => {
  console.log('id:' + id)
  return db.collection('Organizations').doc(id).get();
}

export const getProduct = (id) => {
  return new Promise(function(resolve, reject) {
    db.collection('Products').doc(id).get().then(doc => {
      var obj = doc.data();
      obj.id = doc.id;
      resolve(obj);
    });
  });
}

export const getProducts = () => {
  return new Promise(function(resolve, reject) {
    var baseRef = db.collection('Products');
    baseRef.orderBy("ProductName","asc").get().then(snapshot => {
      var products = [];
      snapshot.forEach((doc) => {
        var d = doc.data();
        d.id = doc.id;
        products.push(d);
      });
      resolve(products);
    });
  });
}

export const getPurchases = (orgID) => {

  var baseRef = db.collection('Purchases');
  var queryRef = baseRef.where('orgId','==',orgID);
  return queryRef.orderBy("created","desc").get();
}

export const getSchool = (id) => {
  return new Promise(function(resolve, reject) {
    db.collection('Schools').doc(id).get().then((doc) => {
      var school;
      console.log(doc)
      if(doc) {
        school = doc.data();
        school.id = doc.id;
      }
      resolve(school);
    });;
  });
}

export const getSchools = (orgID) => {

  var baseRef = db.collection('Schools');
  //var queryRef = baseRef.where('ClassID','==',classID);
  return baseRef.orderBy("Name","desc").get();
}

export const getSettings = (id) => {
  return new Promise(function(resolve, reject) {
    db.collection('Settings').doc(id).get().then(doc => {
      var obj = doc.data();
      obj.id = doc.id;
      resolve(obj);
    });
  });
}

export const getTasks = () => {
  return new Promise(function(resolve, reject) {
    var baseRef = db.collection('Tasks');
    return baseRef.get().then(snapshot => {
      var objs = [];
      snapshot.forEach((doc) => {
        var d = doc.data();
        d.id = doc.id;
        objs.push(d);
      });
      resolve(objs);
    });
  });
}

export const getStudentsByClass = (classID) => {

  var baseRef = db.collection('Users');
  var queryRef = baseRef.where('ClassID','==',classID).where('UserType','==','student');
  return queryRef.orderBy("LastName","desc").get();
}

export const getStudentsByOrg = (orgID) => {

  var baseRef = db.collection('Users');
  var queryRef = baseRef.where('orgId','==',orgID).where('UserType','==','student');
  return queryRef.orderBy("LastName","desc").get();
}

export const getStripeAccount = (id) =>
  db.collection('StripeAccounts').doc(id).get();


export const getUsersBySchool = (schoolID) => {
  var baseRef = db.collection('Users');
  var queryRef = baseRef.where('SchoolID','==',schoolID);
  return queryRef.orderBy("LastName","desc").get();
}

export const getUser = (id) => 
  db.collection('Users').doc(id).get();

export const searchUsers = (query) => {
  return fetch("https://us-central1-keiki-262db.cloudfunctions.net/searchUsers", {
    method: "POST",
    cache: "no-cache",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ query })
  })
  .then(response => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('Search failed');
    }
  })
  .then(data => data.results)
  .catch(error => {
    console.error('Error searching users:', error);
    return [];
  });
};


export const getVideos = (orgID) => {
  var baseRef = db.collection('Videos');
  //var queryRef = baseRef.where('ClassID','==',classID);
  return baseRef.orderBy("Quarter","asc").orderBy("Week","asc").get();
}

export const updateBlogPost = (id, value) => {
  if(typeof id === 'undefined')
    return db.collection('BlogPosts').add(value);
  else 
    return db.collection('BlogPosts').doc(id).set(value);
}

export const updateClass = (id, value) => {
  if(typeof id === 'undefined')
    return db.collection('Classes').add(value);
  else 
    return db.collection('Classes').doc(id).set(value);
}

export const updateCourse = (id, value) => {
  if(typeof id === 'undefined')
    return db.collection('Courses').add(value);
  else 
    return db.collection('Courses').doc(id).set(value);
}

export const updateLesson = (id, value) => {
  if(typeof id === 'undefined')
    return db.collection('Lessons').add(value);
  else 
    return db.collection('Lessons').doc(id).set(value);
}
  
export const updateLocation = (id, value) => {
  if(typeof id === 'undefined')
    return db.collection('Locations').add(value);
  else 
    return db.collection('Locations').doc(id).set(value);
}


export const updateMaterial = (id, value) => {
  if(typeof id === 'undefined')
    return db.collection('Materials').add(value);
  else 
    return db.collection('Materials').doc(id).set(value);
}


export const updateOrder = (id, value) => {
  if(typeof id === 'undefined')
    return db.collection('Orders').add(value);
  else 
    return db.collection('Orders').doc(id).set(value);
}
  
export const updateOrganization = (id, value) => {
  if(id === 0) 
    return db.collection('Organizations').add(value);
  else 
    return db.collection('Organizations').doc(id).set(value);
}

export const updateProduct = (id, value) => {
  if(typeof id === 'undefined')
    return db.collection('Products').add(value);
  else 
    return db.collection('Products').doc(id).set(value);
}

export const updateSchool = (id, value) => {
  if(typeof id === 'undefined')
    return db.collection('Schools').add(value);
  else 
    return db.collection('Schools').doc(id).set(value);
}

export const updateSettings = (id, value) => {
  if(typeof id === 'undefined')
    return db.collection('Settings').add(value);
  else 
    return db.collection('Settings').doc(id).set(value);
}

export const updateTask = (id, value) => {
  if(typeof id === 'undefined')
    return db.collection('Tasks').add(value);
  else 
    return db.collection('Tasks').doc(id).set(value);
}

export const updateUser = (id, value) => {
  if(typeof id === 'undefined')
    return db.collection('Users').add(value);
  else 
    return db.collection('Users').doc(id).set(value);
}

export const updateVideo = (id, value) => {
  if(typeof id === 'undefined')
    return db.collection('Videos').add(value);
  else 
    return db.collection('Videos').doc(id).set(value);
}



// WEBPACK FOOTER //
// ./src/assets/firebase/db.js